














































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import RangeInput from '@/components/RangeInput.vue'

import '@/global-types.ts'

@Component({
  components: {
    RangeInput,
  }
})
export default class TagFilter extends Vue {
  @Prop() reload!: () => void
  @Prop() getDocuments!: () => void
  @Prop() error!: ({ title, message }: { title: string; message: string }) => void
  @Prop() deleteTag!: (label: string) => void
  @Prop() tag!: Tag
  @PropSync('search') dnsearch!: Search

  get status () {
    const yes = this.dnsearch.tags.filter(t => {
      return t[0] === this.tag.label && (t[1] === undefined || t[1] === '') && (t[2] === undefined || t[2] === '')
    }).map(t => t[0])
    const no = this.dnsearch.nottags.filter(t => {
      return t[0] === this.tag.label && (t[1] === undefined || t[1] === '') && (t[2] === undefined || t[2] === '')
    }).map(t => t[0])
    const yesR: [string, (string|number|undefined), (string|number|undefined), true|undefined][] = this.dnsearch.tags.filter(t => {
      return t[0] === this.tag.label
    }).map((e: any) => { e[3] = true; return e })
    const noR = this.dnsearch.nottags.filter(t => {
      return t[0] === this.tag.label
    }).map((e: any) => { e[3] = false; return e })
    return [yes, no, yesR.concat(noR as any)]
  }

  includeTag () {
    const ntIndex = this.dnsearch.nottags.findIndex(t => {
      return t[0] === this.tag.label && t[1] === undefined && t[2] === undefined
    })
    if (ntIndex > -1) {
      this.dnsearch.nottags.splice(ntIndex, 1)
    }
    const tIndex = this.dnsearch.tags.findIndex(t => {
      return t[0] === this.tag.label && t[1] === undefined && t[2] === undefined
    })
    if (tIndex > -1) {
      this.dnsearch.tags.splice(tIndex, 1) // Remove from tags if already present
    } else {
      this.dnsearch.tags.push([this.tag.label, undefined, undefined]) // Add it otherwise
    }
    this.getDocuments()
  }

  excludeTag () {
    const tIndex = this.dnsearch.tags.findIndex(t => {
      return t[0] === this.tag.label && t[1] === undefined && t[2] === undefined
    })
    if (tIndex > -1) {
      this.dnsearch.tags.splice(tIndex, 1)
    }
    const ntIndex = this.dnsearch.nottags.findIndex(t => {
      return t[0] === this.tag.label && t[1] === undefined && t[2] === undefined
    })
    if (ntIndex > -1) {
      this.dnsearch.nottags.splice(ntIndex, 1) // Remove from nottags if already present
    } else {
      this.dnsearch.nottags.push([this.tag.label, undefined, undefined]) // Add it otherwise
    }
    this.getDocuments()
  }

  addRange () {
    this.dnsearch.tags.push([this.tag.label, undefined, undefined])
    this.getDocuments()
  }

  removeRange (min: (string|number|undefined), max: (string|number|undefined), include: boolean) {
    if (include) {
      this.dnsearch.tags.splice(this.dnsearch.tags.indexOf([this.tag.label, min, max]), 1)
    } else {
      this.dnsearch.nottags.splice(this.dnsearch.nottags.indexOf([this.tag.label, min, max]), 1)
    }
    this.getDocuments()
  }

  toggleRange (min: (string|number|undefined), max: (string|number|undefined), wasInclude: boolean) {
    if (wasInclude) {
      this.dnsearch.tags.splice(this.dnsearch.tags.indexOf([this.tag.label, min, max]), 1)
      this.dnsearch.nottags.push([this.tag.label, min, max])
    } else {
      this.dnsearch.nottags.splice(this.dnsearch.nottags.indexOf([this.tag.label, min, max]), 1)
      this.dnsearch.tags.push([this.tag.label, min, max])
    }
    this.getDocuments()
  }

  askDeleteTag () {
    if (confirm(`Delete Tag “${this.tag.label}”?\nThis action cannot be undone.`)) {
      this.deleteTag(this.tag.label)
      this.reload()
    }
  }
}
